<template>
    <div v-if="tags">
        <label for="sessions-select">Session Tags</label>
        <div class="tags-container">
            <div v-for="tag in tags" :key="tag" class="tag-badge mb-3">
              {{ tag }}
              <span title="Remove tag" @click.stop="removeTagFromSession(tag, session.id)">x</span>
            </div>
            <div class="search-container" ref="searchContainerRef">
                <i class="fa fa-tag search-icon"></i>
                <input type="text" class="search-input" placeholder="Add tags" v-model="searchText" @focus="showSuggestions = true" @keyup.enter="enterSessionTag">
                <!-- Suggestions dropdown -->
                <div v-if="showSuggestions && mostUsedsessionTags.size" class="suggestions-dropdown">
                    <div v-for="tag in mostUsedsessionTags" :key="tag.id" @click="addSessionTag(tag)">
                        {{ tag }}
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
import { ref, onMounted, onBeforeUnmount, watch } from 'vue'
import getMostUsedTags from '../../../composables/getMostUsedSessionTags'
import addTagToSession from '../../../composables/addTagToSession'
import removeTagFromSession from '../../../composables/removeTagFromSession'
import getSessionTags from '../../../composables/getSessionTags'

export default ({
  name: 'SessionsTable',
  props: {
    session: Object
  },
  setup (props, { emit }) {
    const showSuggestions = ref(false)
    const { mostUsedsessionTags, loadTags } = getMostUsedTags()
    loadTags()
    const searchText = ref('')

    let { tags, unsubscribe } = getSessionTags(props.session.id)

    onMounted(async () => {
      window.addEventListener('click', outsideClickListener)
    })

    onBeforeUnmount(() => {
      window.removeEventListener('click', outsideClickListener)
      if (unsubscribe) {
        unsubscribe()
      }
    })

    watch(() => props.session.id, (newSessionId, oldSessionId) => {
      if (unsubscribe) {
        unsubscribe()
        unsubscribe = null
      }
      getSessionTags(props.session.id)
    }, { immediate: true })

    const searchContainerRef = ref(null)

    const outsideClickListener = (event) => {
      if (!searchContainerRef.value.contains(event.target) && showSuggestions.value) {
        showSuggestions.value = false
      }
    }

    const enterSessionTag = async () => {
      if (!searchText.value.trim() || tags.value.has(searchText.value.trim())) {
        searchText.value = ''
        return
      }
      const value = searchText.value.trim()
      searchText.value = ''
      await addTagToSession(value, props.session.id, props.session.date, props.session.movements[0] ? props.session.movements[0].name : '', props.session.userId)
    }

    const addSessionTag = async (tag) => {
      showSuggestions.value = false
      if (tags.value.has(tag)) {
        return
      }
      await addTagToSession(tag, props.session.id, props.session.date, props.session.movements[0] ? props.session.movements[0].name : '', props.session.userId)
    }

    return {
      showSuggestions,
      searchContainerRef,
      mostUsedsessionTags,
      addSessionTag,
      searchText,
      enterSessionTag,
      tags,
      removeTagFromSession
    }
  }
})
</script>

<style scoped>
.tag-badge {
    font-size: 14px;
    font-weight: 500;
    cursor: pointer;
    transition: background-color 0.3s;
    position: relative;
    display: inline-block;
    border-radius: 3px;
    margin: .25em .1em;
    margin-right: 10px;
    background-color: var(--light-grey);
    padding: 7px 10px;
    border-radius: 5px;
    align-items: center;
    display: inline-flex;
    margin-right: 5px;

}

.tag-badge span:hover {
    color: red;
}

.tags-container {
    display: flex;
    flex-wrap: wrap;
    align-items: center;
}

.search-container {
    position: relative;
    margin-bottom: 10px;
    font-family: Arial, sans-serif;
    display: inline-flex;
    flex-direction: column;
    z-index: 1;
    align-items: flex-start;
}

.search-input:focus {
    border-color: #b47af3;
}

.search-icon {
    position: absolute;
    top: 50%;
    left: 8px;
    transform: translateY(-50%);
    color: #888;
    cursor: pointer;
}

.search-input {
    padding: 8px;
    padding-left: 30px;
    border: 1px solid #ccc;
    border-radius: 8px;
    font-size: 0.8rem;
    outline: none;
    transition: border-color 0.3s;
}

.suggestions-dropdown {
    position: absolute;
    top: 100%;
    left: 0;
    width: 100%;
    max-height: 150px;
    overflow-y: auto;
    background-color: var(--container-color);
    border: 1px solid var(--border-color);
    border-top: none;
    border-radius: 0 0 8px 8px;
    z-index: 10;
    box-shadow: 0px 4px 8px rgba(0, 0, 0, 0.05);
}

.suggestions-dropdown div {
    padding: 8px;
    font-size: 0.8rem;
    color: var(--muted-text-color);
    cursor: pointer;
    transition: background-color 0.3s, color 0.3s;
}

.suggestions-dropdown div:hover {
    background-color: var(--light-grey);
}

.tag-badge span {
    font-weight: bold;
    display: inline-block;
    margin-left: 5px;
    border-radius: 3px;
    cursor: pointer;
    transition: background-color 0.2s, color 0.2s;
    margin-left: 15px;
    color: var(--muted-text-color);
}

.tag-badge span:hover {
    color: red;
}

</style>
